import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-components-ReactFlow-edges', [
  'deleteEdgeButton',
]);
